import React from 'react'
import './Circle.css'

function Circle() {
    return <div className="circle" />
}

export default Circle
